module["exports"] = [
  "qc.ca",
  "ca",
  "com",
  "biz",
  "info",
  "name",
  "net",
  "org"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/fr_CA/internet/domain_suffix.js
 ** module id = 603
 ** module chunks = 0
 **/